/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { MdKeyboardArrowRight } from 'react-icons/md';
import {
  formatCurrency,
  formatDate,
  getNewDate,
  isMobileWidth,
} from '../../../shared/helper-utils/appUtils';
import {
  DATE_FORMAT,
  DATE_MONTH_YEAR_VIEW_FORMAT,
  MONTH_FORMAT,
  NAVIGATION_ROUTES,
  ONLY_DATE_FORMAT,
} from '../../../shared/constants/Constants';
import AppLink from '../../../shared/components/app-link/AppLink';
import './BookingsList.scss';
import AppIconButton from '../../../shared/components/app-icon-button/AppIconButton';

import AppSidebar from '../../../shared/components/app-sidebar/AppSidebar';
import StarRating from '../search-results/StarRating';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import { performHotelTicketing } from '../../../api/hotelApi';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppModal from '../../../shared/components/app-modal/AppModal';

function CheckInCard({ data }) {
  return (
    <div className="booking-review-page__body__booking-details_check-in-card">
      <span>{data.title}</span>
      <span>
        {data.date ? formatDate(getNewDate(data.date), ONLY_DATE_FORMAT) : ''}
      </span>
      <span>{`${
        data.date ? formatDate(getNewDate(data.date), MONTH_FORMAT) : ''
      }`}</span>
    </div>
  );
}

CheckInCard.propTypes = {
  data: PropTypes.object.isRequired,
};

function HotelBookingsListCard({ bookingData }) {
  const navigate = useNavigate();
  const [showDetails, setShowDetails] = useState(false);
  const [showTnc, setShowTnc] = useState(false);
  const viewDetails = () => {
    let route = NAVIGATION_ROUTES.HOTEL.BOOKING_DETAILS;
    route = route.replace(':transactionId', bookingData.txid);
    navigate(route);
  };
  const [showPerformTicketPopup, setShowPerformTicketPopup] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const getFullName = () => {
    let name = '';
    if (bookingData.leadpassenger_firstname)
      name += ` ${bookingData.leadpassenger_firstname}`;
    if (bookingData.leadpassenger_lastname)
      name += ` ${bookingData.leadpassenger_lastname}`;
    return name;
  };

  const handlePerformBooking = async () => {
    setIsLoading(true);
    const res = await performHotelTicketing(
      bookingData.txid,
      bookingData.payment_mode,
    );
    if (res && res.Root && res.Root.Status === 'OK') {
      setShowPerformTicketPopup(false);
      setAlert({
        variant: 'success',
        title: 'Hold Flight',
        description: `${res?.Root?.Message}, Redirecting to Ticket page...`,
      });
      setTimeout(() => {
        navigate(`/hotel/print-ticket/${bookingData.txid}`);
      }, 2000);
    } else {
      setShowPerformTicketPopup(false);
      setAlert({
        variant: 'error',
        title: 'Hold Flight',
        description: res.Root?.Message || 'Failed to perform booking',
      });
    }
    setIsLoading(false);
  };
  return (
    <>
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          variant={alert.variant}
          showIcon
          title={alert.title}
          description={alert.description}
        />
      )}
      {!isMobileWidth() ? (
        <div className=" my-2 hotel-bookings-list_card">
          <div className="hotel-bookings-list_card_info">
            <div className="p-2 hotel-bookings-list_card_info_hotel_details">
              <Row className="spacing-8">
                <Col lg={9} md={9} sm={12} xs={12}>
                  <Row className="spacing-8 border-bottom pb-2 mb-2">
                    <Col lg={6} md={6} sm={12} xs={12}>
                      <div className="secondary-color fw-500">
                        {bookingData.agent_company}
                      </div>
                      {/* <div className="fs-10">
                        ({bookingData.leadpassenger_city})
                      </div> */}
                    </Col>
                    <Col lg={6} md={6} sm={12} xs={12}>
                      <div className="fw-600">
                        Hotel - {bookingData.booking_status}
                      </div>
                      <div className="fw-600 error-text">
                        <AppLink
                          linkText="Cancellation Policy"
                          variant="red"
                          onClick={() => setShowTnc((prev) => !prev)}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row className="spacing-8">
                    <Col lg={6} md={6} sm={12} xs={12}>
                      <div>{bookingData.hotel_name}</div>
                      <div>
                        <b>Lead Guest:</b> {bookingData.leadpassenger_city}
                      </div>
                    </Col>
                    <Col lg={6} md={6} sm={12} xs={12}>
                      <div>
                        <b>Check In:</b>{' '}
                        {bookingData.checkin_time
                          ? formatDate(
                              getNewDate(
                                bookingData.checkin_time.split(' ')[0],
                              ),
                              DATE_MONTH_YEAR_VIEW_FORMAT,
                            )
                          : ''}
                      </div>
                      <div>
                        <b>Check Out:</b>{' '}
                        {bookingData.checkout_time
                          ? formatDate(
                              getNewDate(bookingData.checkout_time),
                              DATE_MONTH_YEAR_VIEW_FORMAT,
                            )
                          : ''}
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col
                  lg={3}
                  md={3}
                  sm={12}
                  xs={12}
                  className="d-flex justify-content-center"
                >
                  <div className="hotel-bookings-list_card_info_hotel_transaction-details">
                    <div className="d-flex gap-2">
                      <div>
                        <b>Conf No.</b>
                      </div>
                      <div className="word-break">
                        {bookingData.supplier_reference}
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <div>
                        <b>Ref No.</b>
                      </div>
                      <div>{bookingData.txid}</div>
                    </div>
                    <div className="d-flex gap-2">
                      <div>
                        <b>Hotel Conf No.</b>
                      </div>
                      <div>{bookingData.HotelConfirmationNo}</div>
                    </div>
                    <div className="d-flex gap-2">
                      <div>
                        <b>Rs. {bookingData?.farequote_amount?.toFixed(2)}</b>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="p-2 flex-sm-row flex-column hotel-bookings-list_card_info_links">
              <div>
                <b>Booked: </b> {bookingData.tx_date}
              </div>
              <div className="d-flex gap-4">
                {bookingData.booking_status.toLowerCase() === 'onhold' && (
                  <div>
                    <AppLink
                      linkText="Reconfirm"
                      onClick={() => setShowPerformTicketPopup(true)}
                      variant="grey"
                      className="fw-600"
                    />
                  </div>
                )}
                <AppLink
                  linkText="Open"
                  variant="secondary"
                  className="fw-600"
                  onClick={viewDetails}
                />
              </div>
            </div>
            {showTnc && (
              <div className="p-2">
                <div
                  dangerouslySetInnerHTML={{
                    __html: bookingData.canxpolicy_modified.replace(
                      /##/g,
                      '<br>',
                    ),
                  }}
                />
              </div>
            )}
          </div>
          {showPerformTicketPopup && (
            <AppModal
              modalTitle="Perform Ticketing"
              onModalClose={() => setShowPerformTicketPopup(false)}
              showCloseButton
            >
              <div>
                <Row className="spacing-16">
                  <Col
                    className="d-flex flex-column"
                    lg={4}
                    md={4}
                    sm={4}
                    xs={6}
                  >
                    <span className="fs-12">Lead Pax</span>
                    <span className="fs-14 fw-500">{getFullName()}</span>
                  </Col>
                  <Col
                    className="d-flex flex-column"
                    lg={4}
                    md={4}
                    sm={4}
                    xs={6}
                  >
                    <span className="fs-12">TxID</span>
                    <span className="fs-14 fw-500">{bookingData.txid}</span>
                  </Col>
                  <Col
                    className="d-flex flex-column"
                    lg={4}
                    md={4}
                    sm={4}
                    xs={6}
                  >
                    <span className="fs-12">Destination</span>
                    <span className="fs-14 fw-500">
                      {bookingData.hotel_cityreference}
                    </span>
                  </Col>
                  <Col
                    className="d-flex flex-column"
                    lg={4}
                    md={4}
                    sm={4}
                    xs={6}
                  >
                    <span className="fs-12">Booking Date</span>
                    <span className="fs-14 fw-500">
                      {bookingData.tx_date
                        ? formatDate(
                            getNewDate(bookingData.tx_date),
                            DATE_MONTH_YEAR_VIEW_FORMAT,
                          )
                        : ''}
                    </span>
                  </Col>
                  <Col
                    className="d-flex flex-column"
                    lg={4}
                    md={4}
                    sm={4}
                    xs={6}
                  >
                    <span className="fs-12">Checkin Date</span>
                    <span className="fs-14 fw-500">
                      {bookingData.checkin_time
                        ? formatDate(
                            getNewDate(bookingData.checkin_time),
                            DATE_FORMAT,
                          )
                        : ''}
                    </span>
                  </Col>
                  <Col
                    className="d-flex flex-column"
                    lg={4}
                    md={4}
                    sm={4}
                    xs={6}
                  >
                    <span className="fs-12">Booking Status</span>
                    <span className="fs-14 fw-500">
                      {bookingData.booking_status}
                    </span>
                  </Col>
                </Row>
                <p className="text-center fs-18 fw-500 mt-3 mb-1">
                  Are you sure!? Do you want to Perform Ticketing?
                </p>
                <div className="d-flex gap-2 justify-content-center">
                  <AppButton
                    btnText="No"
                    variant="outlined"
                    className="flex-1"
                    onClick={() => setShowPerformTicketPopup(false)}
                  />
                  <AppButton
                    btnText="Yes"
                    variant="primary"
                    className="flex-1"
                    onClick={handlePerformBooking}
                  />
                </div>
              </div>
            </AppModal>
          )}
        </div>
      ) : (
        <div>
          <div
            className="d-flex justify-content-between flight-list-card"
            onClick={() => setShowDetails(true)}
          >
            <div className="d-flex gap-4">
              <div className="gap-1">
                <div className="fs-16 fw-600">{bookingData.hotel_name}</div>
                <div className="fs-14">
                  Hotel in {bookingData.hotel_cityreference}
                </div>
                <div className="grey-color">
                  <span className=" fw-500 fs-12">
                    {formatDate(
                      getNewDate(bookingData.checkin_time),
                      DATE_MONTH_YEAR_VIEW_FORMAT,
                    )}
                  </span>{' '}
                  |{' '}
                  <span className=" fw-500 fs-12">
                    {formatDate(
                      getNewDate(bookingData.checkout_time),
                      DATE_MONTH_YEAR_VIEW_FORMAT,
                    )}
                  </span>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <AppIconButton variant="transparent">
                <MdKeyboardArrowRight className="fs-1 primary-color" />
              </AppIconButton>
            </div>
          </div>
          {showDetails && (
            <AppSidebar
              sidebarTitle="Hotel Booking Details"
              onHideSidebar={() => setShowDetails(false)}
              animatedClass="slide-from-right-animation"
              className="app-mobile-datepicker-modal"
            >
              <div className="booking-review-page__body">
                <div className="booking-review-page__body_content">
                  <div className="d-flex flex-column py-2">
                    <div className="d-flex gap-2 flex-wrap">
                      <span className="booking-review-page__body__booking-details_hotel-name">
                        {bookingData.hotel_name}
                      </span>
                      <StarRating rating={bookingData.hotel_rating} />
                    </div>
                    <span className="booking-review-page__body__booking-details_hotel-location">
                      {bookingData.hotel_address}
                    </span>
                    <div className="d-flex gap-2 flex-column flex-sm-row mt-2">
                      <div className="d-flex gap-1">
                        <CheckInCard
                          data={{
                            title: 'Check in',
                            date: bookingData.checkin_time,
                          }}
                        />
                        <CheckInCard
                          data={{
                            title: 'Check out',
                            date: bookingData.checkout_time,
                          }}
                        />
                        <div className="booking-review-page__body__booking-details_check-in-card">
                          <span> Room(s)</span>
                          <span className="pt-2 pb-2">
                            {bookingData.noof_rooms}
                          </span>
                        </div>
                        <div className="booking-review-page__body__booking-details_check-in-card">
                          <span> Pax</span>
                          <span className="pt-2 pb-2">
                            {Number(bookingData.noof_adults) +
                              Number(bookingData.noof_childs) +
                              Number(bookingData.noof_infants)}
                          </span>
                        </div>
                      </div>
                      <div className="py-2">
                        <span className="fs-12 fw-300">Room Type : </span>
                        <div className="fs-14 fw-600">
                          {bookingData.room_type}
                        </div>
                        {/* <div className="fs-14 mb-2">
                            {formattedMessage('for')} {bookingData.noof_adults}{' '}
                            {formattedMessage('people')}
                          </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between px-3 text-capitalize">
                <div className="fs-12 primary-color">Total Amount</div>
                <div className="fs-14 fw-500">
                  {formatCurrency(bookingData.OriginalPrice)}
                </div>
              </div>
              <div className="p-2">
                <div className="d-flex justify-content-between bg-body-secondary p-2">
                  <div className="fs-12 primary-color">Traveller</div>
                  <div className="fs-12 primary-color">Mobile No</div>
                </div>

                <div className="d-flex justify-content-between p-2 text-capitalize">
                  <div className="fs-14 fw-500">
                    {bookingData.leadpassenger_firstname}{' '}
                    {bookingData.leadpassenger_lastname}
                  </div>
                  <div className="fs-14 fw-500">
                    {bookingData.leadpassenger_mobile}
                  </div>
                </div>
              </div>
            </AppSidebar>
          )}
          {showPerformTicketPopup && (
            <AppModal
              modalTitle="Perform Ticketing"
              onModalClose={() => setShowPerformTicketPopup(false)}
              showCloseButton
            >
              <div>
                <Row className="spacing-16">
                  <Col
                    className="d-flex flex-column"
                    lg={4}
                    md={4}
                    sm={4}
                    xs={6}
                  >
                    <span className="fs-12">Lead Pax</span>
                    <span className="fs-14 fw-500">{getFullName()}</span>
                  </Col>
                  <Col
                    className="d-flex flex-column"
                    lg={4}
                    md={4}
                    sm={4}
                    xs={6}
                  >
                    <span className="fs-12">TxID</span>
                    <span className="fs-14 fw-500">{bookingData.txid}</span>
                  </Col>
                  <Col
                    className="d-flex flex-column"
                    lg={4}
                    md={4}
                    sm={4}
                    xs={6}
                  >
                    <span className="fs-12">Destination</span>
                    <span className="fs-14 fw-500">
                      {bookingData.hotel_cityreference}
                    </span>
                  </Col>
                  <Col
                    className="d-flex flex-column"
                    lg={4}
                    md={4}
                    sm={4}
                    xs={6}
                  >
                    <span className="fs-12">Booking Date</span>
                    <span className="fs-14 fw-500">
                      {bookingData.tx_date
                        ? formatDate(
                            getNewDate(bookingData.tx_date),
                            DATE_MONTH_YEAR_VIEW_FORMAT,
                          )
                        : ''}
                    </span>
                  </Col>
                  <Col
                    className="d-flex flex-column"
                    lg={4}
                    md={4}
                    sm={4}
                    xs={6}
                  >
                    <span className="fs-12">Checkin Date</span>
                    <span className="fs-14 fw-500">
                      {bookingData.checkin_time
                        ? formatDate(
                            getNewDate(bookingData.checkin_time),
                            DATE_FORMAT,
                          )
                        : ''}
                    </span>
                  </Col>
                  <Col
                    className="d-flex flex-column"
                    lg={4}
                    md={4}
                    sm={4}
                    xs={6}
                  >
                    <span className="fs-12">Booking Status</span>
                    <span className="fs-14 fw-500">
                      {bookingData.booking_status}
                    </span>
                  </Col>
                </Row>
                <p className="text-center fs-18 fw-500 mt-3 mb-1">
                  Are you sure!? Do you want to Perform Ticketing?
                </p>
                <div className="d-flex gap-2 justify-content-center">
                  <AppButton
                    btnText="No"
                    variant="outlined"
                    className="flex-1"
                    onClick={() => setShowPerformTicketPopup(false)}
                  />
                  <AppButton
                    btnText="Yes"
                    variant="primary"
                    className="flex-1"
                    onClick={handlePerformBooking}
                  />
                </div>
              </div>
            </AppModal>
          )}
        </div>
      )}
    </>
  );
}

HotelBookingsListCard.propTypes = {
  bookingData: PropTypes.any.isRequired,
};

export default HotelBookingsListCard;
